// LIBRARIES
import styled from "styled-components";

// MISC
import { COLORS, DEVICE_TYPE, MARGIN, SIZE } from "../../constants/variables";

export const SliderWrapper = styled.div`
  height: 68vh;
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    height: 95vh;
  }
`;

export const Circle = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.active ? COLORS.VividAuburn : COLORS.MetalicSilver};
  margin-top: ${SIZE.max10};
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    /* margin-top: ${SIZE.max28}; */
    margin-top: 1.5vh;
  }
`;

export const SliderItem = styled.div`
  height: 65vh;
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    height: 90vh;
  }
`;
